// ciclo-vida-04 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Arraste os pontos ou digite os dias pra definir quando o cliente entra em risco e quando fica inativo.": "Arrastra los puntos o escribe los días para definir cuándo el cliente entra en riesgo y cuándo queda inactivo.",
    "a partir de": "a partir de",
};

export default catalogo;
